export const pricingItems = {
  "en": {
    header1: "For individuals",
    header2: "For teams & businesses",
    buttonLabel1: "Pay annually",
    buttonLabel2: "Pay monthly",
    savingPopUp: "Pay annually and save 20%",
    details: [
      [
        { 
          category: 'individual',
          id: 'personal',
          title: 'Personal',
          priceFree: '$0',
          buttonTxt: 'Get started',
          summary: 'For everyone trying out Delight for an unlimited period of time',
          heading: 'Free for individuals',
          items: ['Unlimited channels', '100 projects', '2500 MAU included', 'Sandbox and publishing service'] 
        },
        {
          category: 'individual',
          id: 'personal-pro',
          title: 'Personal Pro',
          priceAnnual: '$8',
          priceMonthly: '$10',
          unitOne: 'per month',
          buttonTxt: 'Try it free',
          summary: 'For power users who want to do more',
          heading: 'Everything in Personal, plus',
          items: ['Unlimited channels', 'Unlimited storage', '5000 MAU included']
        }
      ],
      [
        {
          category: 'business',
          id: 'team',
          title: 'Team',
          priceAnnual: '$15',
          priceMonthly: '$20',
          unitOne: 'per member',
          unitTwo: 'per month',
          buttonTxt: 'Try it free',
          summary: 'For teams working together on the same project',
          heading: 'Everything in Personal Pro, plus',
          items: ['Team collaboration', 'Unlimited team members', 'Premium Templates', 'Unlimited conversation history']
        },
        {
          category: 'business',
          id: 'enterprise',
          title: 'Enterprise',
          priceCustom: 'Contact sales →',
          buttonTxt: 'Try it now',
          summary: 'For businesses with support and customer success needs',
          heading: 'Everything in Team, plus',
          items: ['Designated customer success manager', 'Priority support', 'Onboarding, implementations and operations guidance', 'Custom NLP / NLU']
        }
      ]
    ]
  },
  "zh": {
    header1: "个人帐户",
    header2: "团队及企业",
    buttonLabel1: "年缴",
    buttonLabel2: "月缴",
    savingPopUp: "节省20%",
    details: [
      [
        { 
          category: 'individual',
          id: 'personal',
          title: '入门级',
          priceFree: '$0',
          buttonTxt: '立即开始',
          summary: '个人使用最佳方案，不设时限',
          heading: '个人使用免费',
          items: ['频道数量不限', '100个项目', '2,500个MAU', '测试及频道发布服务'] 
        },
        {
          category: 'individual',
          id: 'personal-pro',
          title: '进阶级',
          priceAnnual: '$8',
          priceMonthly: '$10',
          unitOne: '/月',
          buttonTxt: '免费试用',
          summary: '专业用家的进阶方案，触及更广',
          heading: '入门版的所有功能，再加',
          items: ['无限频道连线', '无上限储存量', '5,000个MAU']
        }
      ],
      [
        {
          category: 'business',
          id: 'team',
          title: '团队',
          priceAnnual: '$15',
          priceMonthly: '$20',
          unitOne: '/人',
          unitTwo: '/月',
          buttonTxt: '免费试用',
          summary: '供团队使用的协作方案，线上共创',
          heading: '个人进阶版的所有功能，再加',
          items: ['团队协作', '团队成员无上限', '高阶范本，行业适用', '用户对话，历史保存无上限']
        },
        {
          category: 'business',
          id: 'enterprise',
          title: '企业',
          priceCustom: '联络我们 →',
          buttonTxt: '免费试用',
          summary: '企业为本的客服和技术支援，想您所想',
          heading: '团队方案的所有功能，再加',
          items: ['指定客户服务经理', '优先支援', '员工培训', '客制执行指引', '客制NLP/NLU']
        }
      ]
    ]
  },
  "zh-hk": {
    header1: "個人方案",
    header2: "團隊及企業",
    buttonLabel1: "年繳",
    buttonLabel2: "月繳",
    savingPopUp: "節省20%",
    details: [
      [
        { 
          category: 'individual',
          id: 'personal',
          title: '入門版',
          priceFree: '$0',
          buttonTxt: '立即開始',
          summary: '個人使用最佳方案，不設時限',
          heading: '個人使用免費',
          items: ['頻道數量不限', '100個項目', '2,500個MAU', '測試及頻道發佈服務'] 
        },
        {
          category: 'individual',
          id: 'personal-pro',
          title: '個人進階版',
          priceAnnual: '$8',
          priceMonthly: '$10',
          unitOne: '/月',
          buttonTxt: '免費試用',
          summary: '專業用家的進階方案，受眾更廣',
          heading: '入門版所有功能，再加',
          items: ['無限頻道連線', '無上限儲存量', '5,000個MAU']
        }
      ],
      [
        {
          category: 'business',
          id: 'team',
          title: '團隊',
          priceAnnual: '$15',
          priceMonthly: '$20',
          unitOne: '/人',
          unitTwo: '/月',
          buttonTxt: '免費試用',
          summary: '供團隊使用的協作方案，線上齊創建',
          heading: '個人進階版所有功能，再加',
          items: ['團隊協作', '團隊成員無上限', '高階範本，行業適用', '用戶對話，保存無上限']
        },
        {
          category: 'business',
          id: 'enterprise',
          title: '企業',
          priceCustom: '聯絡我們 →',
          buttonTxt: '免費試用',
          summary: '企業為本的客服及終端使用者的支援，更貼心',
          heading: '團隊方案所有功能，再加',
          items: ['指定客戶服務經理', '優先支援', '員工培訓', '操作指南', '客製 NLP/NLU']
        }
      ]
    ]
  },
}